import { atom } from 'nanostores'
import { useStore } from '@nanostores/react'

export type LayoutMobilePanelSide = 'left' | 'right'

export const layoutMobilePanel = atom<LayoutMobilePanelSide>('left')

export const showLeftPanel = (delay = 200): Promise<void> => {
  layoutMobilePanel.set('left')
  return new Promise(resolve => setTimeout(resolve, delay))
}

export const showRightPanel = (delay = 200): Promise<void> => {
  layoutMobilePanel.set('right')
  return new Promise(resolve => setTimeout(resolve, delay))
}

export const isLeftPanelVisible = (side: LayoutMobilePanelSide) => side === 'left'

export const isRightPanelVisible = (side: LayoutMobilePanelSide) => side === 'right'

export const useLayoutPanel = () => {
  const side = useStore(layoutMobilePanel)

  return {
    showLeftPanel: isLeftPanelVisible(side),
    showRightPanel: isRightPanelVisible(side),
    side,
  }
}

export const LayoutPanel = {
  layoutMobilePanel,
  showLeftPanel,
  showRightPanel,
  isLeftPanelVisible,
  isRightPanelVisible,
  useLayoutPanel,
}